<template>
  <button
    ref="button"
    class="modern-account-trigger"
    type="button"
    aria-label="Abrir menú de cuenta"
    aria-haspopup="dialog"
    :aria-expanded="String(open)"
    @click="$emit('toggle')"
  >
    <span class="modern-account-trigger__avatar" aria-hidden="true">{{ initials }}</span>
    <span v-if="badge" class="modern-account-trigger__badge">{{ badge }}</span>
  </button>
</template>

<script>
export default {
  name: 'ModernAccountTrigger',
  props: {
    initials: { type: String, required: true },
    unreadCount: { type: Number, default: 0 },
    open: { type: Boolean, default: false }
  },
  computed: {
    badge() { return this.unreadCount > 9 ? '9+' : (this.unreadCount || ''); }
  },
  methods: {
    focus() { this.$refs.button && this.$refs.button.focus(); }
  }
};
</script>
